import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PersonNameShouldContainAtLeastOneSpace extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.client.validation.name.person-name-should-contain-at-least-one-space');
    }
}
